__turbopack_context__.v({
  "container": "ApplyOpenCallTimes-module__jIE3uW__container",
  "empty": "ApplyOpenCallTimes-module__jIE3uW__empty",
  "fadeInItems": "ApplyOpenCallTimes-module__jIE3uW__fadeInItems",
  "spacing--lg": "ApplyOpenCallTimes-module__jIE3uW__spacing--lg",
  "spacing--md": "ApplyOpenCallTimes-module__jIE3uW__spacing--md",
  "spacing--sm": "ApplyOpenCallTimes-module__jIE3uW__spacing--sm",
  "spacing--xl": "ApplyOpenCallTimes-module__jIE3uW__spacing--xl",
  "spacing--xs": "ApplyOpenCallTimes-module__jIE3uW__spacing--xs",
  "spacing--xxl": "ApplyOpenCallTimes-module__jIE3uW__spacing--xxl",
  "spacing--xxs": "ApplyOpenCallTimes-module__jIE3uW__spacing--xxs",
  "spacing--xxxl": "ApplyOpenCallTimes-module__jIE3uW__spacing--xxxl",
  "spacing--xxxs": "ApplyOpenCallTimes-module__jIE3uW__spacing--xxxs",
  "subTitle": "ApplyOpenCallTimes-module__jIE3uW__subTitle",
  "text": "ApplyOpenCallTimes-module__jIE3uW__text",
  "timeDay": "ApplyOpenCallTimes-module__jIE3uW__timeDay",
  "timeRow": "ApplyOpenCallTimes-module__jIE3uW__timeRow",
  "timeTime": "ApplyOpenCallTimes-module__jIE3uW__timeTime",
  "times": "ApplyOpenCallTimes-module__jIE3uW__times",
  "title": "ApplyOpenCallTimes-module__jIE3uW__title",
});
